// @/components/auth/AuthContainer.jsx
// Animated wrapper for auth cards

import React from "react";
import { motion } from "motion/react";
import { INTRO } from '@/components/reusable/animations';
import clsx from "clsx";

const AuthContainer = ({ children, className, animate = true, footerContent }) => {
  const animationProps = animate ? INTRO : {};

  return (
    <motion.div className={clsx(className)} {...animationProps}>
      {children}
      {footerContent}
    </motion.div>
  );
};

export default AuthContainer;
